import React from "react";
import { Heading, List, Icon, Text, IconName } from "@telia/teddy";
import { SellingPoints } from "../../../../../../models";
import "./KeySellingPoints.less";

interface Props {
    sellingPoints?: SellingPoints[];
}

const KeySellingPoints = ({ sellingPoints = [] }: Props) => {
    if (sellingPoints.length === 0) return null;

    return (
        <List layout="horizontal" className="key-selling-points__list">
            {sellingPoints.map((point) => (
                <List.Item key={point.heading} className="key-selling-points__item">
                    <List.Illustration variant="icon-gray">
                        <Icon size="lg" name={point.icon as IconName} aria-hidden="true" focusable="false" />
                    </List.Illustration>
                    <List.Content className="key-selling-points__content">
                        <Heading mb="100" as={point.headingTag ?? "h2"} variant="title-100">
                            {point.heading}
                        </Heading>
                        {point.content && (
                            <Text asChild variant="paragraph-100">
                                <div dangerouslySetInnerHTML={{ __html: point.content }} />
                            </Text>
                        )}
                    </List.Content>
                </List.Item>
            ))}
        </List>
    );
};

export default KeySellingPoints;
